import SiteFilterModal from './site-filter-modal.connect'

export default SiteFilterModal
